<template>
    <div class="grid grid-cols-2">
      <template v-if="listHistorico && listHistorico?.length > 0">
          <SelectDefault v-model="cittChange" label="Fecha" :options="listHistorico" option-text="fecha" option-value="cittId" :clear="true" @change="changeOdontograma"/>
          <div class="col-span-2">
            <OdontogramaCanvas
              v-if="!isChanged && cittChange && ciadChange && xml" 
              :is-view="true"
              :odontograma="odontograma"
              :ciad-id="ciadChange"
              :citt-id="cittChange"
              :dibujar-en-el-d-o-m="dibujarEnElDOM"
              :xml="xml"
            />
          </div>
      </template>
      <div v-else class="col-span-2">
          <div class="font-semibold text-xl text-black">Sin odontogramas anteriores...</div>
      </div>
    </div>
</template>
<script setup lang="ts">
import type { IHistoryOdontograma } from '@/modules/Asistencial/interfaces/IOdontograma';
import type { IConfOdontogramas } from '@/modules/Configuracion/interfaces';
import { odontologicaService } from '@/services';
import { nextTick, onMounted, ref } from 'vue';
import OdontogramaCanvas from './OdontogramaCanvas.vue';
import { useOdontograma } from '@/modules/Asistencial/composables/useOdontograma';
const { dibujarEnElDOM, generarSVG } = useOdontograma('view')
const props = defineProps<{
  cittId: number,
  odontograma: IConfOdontogramas
}>()
const isChanged = ref(true)
const cittChange = ref<number | null>(null)
const ciadChange = ref<number | null>(null)
const xml = ref<string | null>(null)
const changeOdontograma = async () => {
  isChanged.value = true
  xml.value = null
  const newCiad = listHistorico.value?.find(e => e.cittId == cittChange.value)
  if(newCiad) ciadChange.value = newCiad.ciadId
  const { data } = await odontologicaService.listOdontologicas(cittChange.value as number, odontograma.coodId as number)
  
  xml.value = await generarSVG(props.odontograma, (cittChange.value as number), true, { isView: true, data: data.body })
  await nextTick()
  isChanged.value = false
}
const { cittId, odontograma } = props
const listHistorico = ref<IHistoryOdontograma[]>()
onMounted(async () => {
 const { data } = await odontologicaService.listHistory(cittId, odontograma.coodId as number, { limit: 12 })
 listHistorico.value = data.body
})
</script>